import qs from 'query-string';

export type SearchParams = { [key: string]: string | undefined };

export const toSearchParams = (search: string) => qs.parse(search) as SearchParams;
